import {Grid, UnstableCard as Paper} from '@yandex-delivery/blocks'
import {filter, flow, get, includes, map} from '@yandex-delivery/utils'
import {type FC, type ReactNode, Children} from 'react'

import {AddressWidget, PickupWidget} from '../Address/desktop'
import {type AddressWidgetConfig, type SectionProps as Props, type WidgetConfig, WidgetType} from '../types'

export const Route: FC<Props> = flow(
  get('section.widgets'),
  filter((widget: WidgetConfig): widget is AddressWidgetConfig => widget.type === WidgetType.ADDRESS),
  map((widget: AddressWidgetConfig): ReactNode => {
    return (
      <Grid xs={12} item>
        <Paper padding="none" radius="L">
          {isPickupWidget(widget) ? <PickupWidget config={widget} /> : <AddressWidget config={widget} />}
        </Paper>
      </Grid>
    )
  }),
  Children.toArray,
)
Route.displayName = 'RouteDesktop'

const isPickupWidget: (widget: AddressWidgetConfig) => boolean = flow(
  get('widget_id'), //
  includes('ndd'),
)
